// ─────────────────────────────────────────────────────────────
// src/pages/TaxCalculator/components/CalculationModeToggle.jsx
// Renders the Net-from-Gross / Gross-from-Net toggle cards.
// Pure UI – receives everything via props.
// ─────────────────────────────────────────────────────────────

import React from "react";
import { Calculator, TrendingDown, TrendingUp } from "lucide-react";

const CalculationModeToggle = ({
  calculationMode,
  processingMode,
  onSelectMode,
  styles,
  t,
}) => (
  <div style={styles.card}>
    <h3
      style={{
        ...styles.calcModeTitle,
        fontSize:     "20px",
        marginBottom: "20px",
      }}
    >
      <Calculator size={20} />
      {t.selectCalculationType}
    </h3>

    <div style={styles.calcModeToggle}>
      <div
        style={styles.calcModeButton(calculationMode === "netFromGross")}
        onClick={() => onSelectMode("netFromGross")}
      >
        <div style={styles.calcModeTitle}>
          <TrendingDown size={20} />
          {t.calculateNetFromGross}
        </div>
        <div style={styles.calcModeDesc}>
          {processingMode === "individual" ? t.netFromGrossDesc : t.netFromGrossExcelDesc}
        </div>
      </div>

      <div
        style={styles.calcModeButton(calculationMode === "grossFromNet")}
        onClick={() => onSelectMode("grossFromNet")}
      >
        <div style={styles.calcModeTitle}>
          <TrendingUp size={20} />
          {t.calculateGrossFromNet}
        </div>
        <div style={styles.calcModeDesc}>
          {processingMode === "individual" ? t.grossFromNetDesc : t.grossFromNetExcelDesc}
        </div>
      </div>
    </div>
  </div>
);

export default CalculationModeToggle;